import { render } from "./EditTileGameContent.vue?vue&type=template&id=0831796c"
import script from "./EditTileGameContent.vue?vue&type=script&lang=js"
export * from "./EditTileGameContent.vue?vue&type=script&lang=js"

import "./EditTileGameContent.vue?vue&type=style&index=0&id=0831796c&lang=scss&setup=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__